import React, { useState } from "react";
import { Assort } from "../../../../models/Assort";

interface IProps {
  item: Assort;
  onAddLine: (assort: Assort, qnt: number) => void;
}

const AssortLineQntButtons: React.FC<IProps> = ({ item, onAddLine }) => {
  const [qnt, setQnt] = useState<number>(0);
  return (
    <>
      {" "}
      {qnt === 0 ? (
        <button className="flex-center-center qnt-button qnt-opacity onclick-button-move-up">-</button>
      ) : (
        <button
          className="flex-center-center qnt-button onclick-button-move-up"
          onClick={() => {
            onAddLine(item, -1);
            setQnt(qnt - 1);
          }}
        >
          -
        </button>
      )}
      <input className="qnt-input" type="number" value={qnt} />
      <button
        className="flex-center-center qnt-button onclick-button-move-up"
        onClick={() => {
          onAddLine(item, 1);
          setQnt(qnt + 1);
        }}
      >
        +
      </button>
    </>
  );
};

export default AssortLineQntButtons;
